import ResetPasswordContainer from "../../features/auth/components/ResetPasswordForm";

const ResetPassword = () => {
  return <ResetPasswordContainer />;
};

export default ResetPassword;
